module.exports = __webpack_public_path__ + "static/assets/dc685034141f1d53513e90539b4e2436.png";